

export const primengLocaleDe = {
  accept: 'Ja',
  reject: 'Nein',
  selectionMessage: '{0} Elemente ausgewählt'
}
